import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { BASE_URL, getNewList } from '../api/api'
import useMediaQuery from '../hooks/useMediaQuery'
import Layout from './layout'
import Subpages from './public/subpages'
import NavLink from './navLink'

const Spbf = () => {
  const { channel_id = 1 } = useParams()
  const [data, setData] = useState([])
  const isMobile = useMediaQuery()

  useEffect(() => {
    getNewList(`archives/videoshow?id=${channel_id}`.replace('.html', '')).then(res => {
      setData(res?.data)
    })
  }, [channel_id])
  return (
    <Layout>
      <Subpages className="p-5 lg:p-0" name={data?.channel?.name || '视频播放'}>
        <video
          className="mx-auto"
          width={849}
          height={637}
          controls
          src={`${BASE_URL}${data?.data?.video_file || ''}`}
        >
          <source src={`${BASE_URL}${data?.data?.video_file || ''}`} type="video/mp4" />
          {/* <source src="video.webm" type="video/webm" /> */}
          <p>您的浏览器不支持HTML5视频。</p>
        </video>
        <div className="mt-[70px] mb-10 lg:mb-0">
          <p className="pb-2 border-b-[3px] border-[#0189D5] max-w-[141px]">更多视频</p>
          <div className="mt-7 bg-[#0181C9] p-4 flex flex-col lg:flex-row justify-between">
            {data?.more?.map(({ id, title1 = '', title, outlink = '' }) => (
              <NavLink
                isOutLink={!!outlink}
                className="lg:w-[273px] mt-10 lg:mt-0"
                to={outlink || `/spbf/channel_id/${id}`}
              >
                <img
                  style={{ width: isMobile ? '100%' : 273 }}
                  className="border border-white"
                  src={`${BASE_URL}${title1}`}
                  alt=""
                />
                <p className="text-white font-alhpr text-[20px] mt-4 text-center">{title}</p>
              </NavLink>
            ))}
          </div>
        </div>
      </Subpages>
    </Layout>
  )
}

export default Spbf
